import * as AuthenticationContext from 'adal-angular';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from 'src/components/App/App';
import { AuthenticationOptions } from 'src/components/Globals/Globals';
import registerServiceWorker from 'src/registerServiceWorker';
import {
  authenticate,
  makeAuthenticationContext,
  mergeAuthenticationOptions
} from './authentication/Authentication';
import { IAuthConfig } from './authentication/IAuthConfig';
import './index.css';

function getAuthOptions(): Promise<IAuthConfig> {
  return fetch(AuthenticationOptions.authConfigEndpointUri).then(response => {
    return response.json();
  });
}
getAuthOptions().then((authOptions: IAuthConfig) => {
  const fullAuthenticationOptions: AuthenticationContext.Options = mergeAuthenticationOptions(
    AuthenticationOptions,
    authOptions
  );
  const authenticationContext = makeAuthenticationContext(fullAuthenticationOptions);
  const authenticationResult = authenticate(authenticationContext);
  if (authenticationResult.isOk) {
    ReactDOM.render(
      <BrowserRouter>
        <App authenticationResult={authenticationResult} />
      </BrowserRouter>,
      document.getElementById('root') as HTMLElement
    );
    registerServiceWorker();
  } else if (authenticationResult.error) {
    // We should show some kind of error here, but not really specified how!
  }
});



// WEBPACK FOOTER //
// ./src/index.tsx